<template>
  <!--新增、修改界面-->
  <div v-if="formVisible">
    <el-dialog
      v-dragDialog
      title="添加备注"
      :visible.sync="formVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        ref="dataForm"
        label-width="120px"
        :rules="addRules"
      >
        <el-form-item label="新增备注：" prop="AddDesc">
          <el-input
            v-model="addForm.AddDesc"
            type="textarea"
            auto-complete="off"
            rows="6"
            placeholder="请输入新增备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="已有备注：" prop="OldDesc">
          <el-input
            v-model="addForm.OldDesc"
            type="textarea"
            disabled
            auto-complete="off"
            rows="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addProcessNote as addOrder } from "@/api/bussiness/order";
import { addDesc } from "@/api/bussiness/commet";
export default {
  components: {},
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
  },
  watch: {
    value: {
      handler(val) {},
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formVisible: false,
      formTitle: "创建",
      from: "",
      AddTask: "",
      addForm: {
        Key: "",
        AddDesc: "",
        OldDesc: "",
      },
      addRules: {
        AddDesc: [{ required: true, message: "请输入备注", trigger: "change" }],
      },
    };
  },
  methods: {
    //创建任务
    Show: function (task, from) {
      this.from = from;
      this.formVisible = true;
      this.AddTask = task;
      (this.addForm = {
        Key: this.AddTask.Key,
        AddDesc: "",
        OldDesc: this.AddTask.Description,
      }),
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate();
        });
    },
    handleSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm);
          if (this.from == "Order") {
            addOrder(para).then((response) => {
              if (response) {
                this.formVisible = false;
                this.AddTask.Description = response;
              }
            });
          }
          if (this.from == "Comment") {
            addDesc(para).then((response) => {
              if (response) {
                this.formVisible = false;
                this.AddTask.Description = response;
              }
            });
          }
        }
      });
    },
  },
};
</script>